import React from 'react';
import { useHistory } from 'react-router-dom';
import './index.less';
import PageLayout from '../../Components/pageLayout';
import data42 from '../../data/data42.json'
import ArticleList from '../../Components/ArticleList';

const IntegrityConstruction: React.FC = () => {
    const history = useHistory();

    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>清廉建设</h1>
                <ArticleList dataId="42" data={data42 as any} />
            </div>
        } />
    );
};

export default IntegrityConstruction;